<template>
  <div class="task taskTree">
    <transition name="fade" mode="out-in">
      <spinner-loading v-if="treeLoading" class="spinner-loading" :size="18" :line-size='2' line-fg-color='#5dbecd' />
      <definition-tree v-else-if="tree"
        :tree="tree"
        :language="language"
        @clickedText="updateValues"
        @expand="markValues"
        @internalData="getTreeInternalData"
      />
    </transition>
  </div>
</template>

<script>
import * as api from '../../utils/definitionApi'
import SpinnerLoading from 'vue-simple-spinner'
import DefinitionTree from '../tree'
import language from '../../language'
import transport from 'vue-definition-utils/src/utils/transport'

const opacityFull = '1'
const opacityEmpty = '0.4'

export default {
  name: 'definition-task-tree',
  props: [
    'task',
    'definition',
    'object',
    'taskRefresh',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'languageSelected',
    'language',
    'authorization',
    'type',
    'apiparams',
    'visuals',
    'istoggle',
    'callTask'
  ],
  components: {
    DefinitionTree,
    SpinnerLoading
  },
  data () {
    return {
      tree: null,
      treeLoading: false,
      internalData: null
    }
  },
  methods: {
    getLang (key) {
      return language(this.language, key)
    },
    getTreeInternalData (internalData) {
      this.internalData = internalData
    },
    markValues () {
      this.updateNodesStyle()
    },
    updateNodesStyle () {
      var reqObj = transport.methods.getRequestObjectById(this.definition.id, this.object)
      if (reqObj && reqObj.domainValue) {
        this.updateNodeElements(reqObj.domainValue, opacityFull)
        var removeDomain = this.definition.validation.domain.filter(item => {
          var notFound = true
          for (var i = 0; i < reqObj.domainValue.length && notFound; i++) {
            notFound = reqObj.domainValue[i].key !== item.key
          }
          return notFound
        })
        this.updateNodeElements(removeDomain, opacityEmpty)
        this.updateIntermediateElements()
      }
    },
    updateIntermediateElements () {
      if (this.internalData) {
        var definedNodes = this.internalData.svg.selectAll('g.nodetree .not-end').data(this.internalData.root.data)._exit[0]
        if (definedNodes) {
          definedNodes.forEach((node) => {
            var dataNodes = this.getDataNode(node.id, node.dataset, this.internalData.root.data)
            dataNodes.forEach((dataNode) => {
              var childValues = this.getTreeValues(dataNode, this.task.type.modeView)
              var elem = node.parentElement.parentElement
              if (this.oneValueIsSelected(childValues)) {
                elem.style['opacity'] = opacityFull
              } else {
                elem.style['opacity'] = opacityEmpty
              }
            })
          })
        }
      }
    },
    getDataNode (id, dataset, data) {
      var result = []
      if (data.id && data.id === id) {
        result.push(data)
      } else if (data.parentId && data.parentId === dataset.parentId && data.alphabeticalIndex && data.alphabeticalIndex === dataset.alphabeticalIndex) {
        result.push(data)
      }
      if (data.children) {
        for (var i = 0; i < data.children.length; i++) {
          result = result.concat(this.getDataNode(id, dataset, data.children[i]))
        }
      }
      return result
    },
    updateNodeElements (domValues, opacity) {
      if (this.internalData && domValues) {
        domValues.forEach((domValue) => {
          var definedNodes = this.internalData.svg.selectAll('#' + domValue.key).data(this.internalData.root.data)._exit[0]
          if (definedNodes.length > 0) {
            definedNodes.forEach((node) => {
              node.parentElement.parentElement.style['opacity'] = opacity
            })
          }
        })
      }
    },
    updateValues (text) {
      var data = text.data

      var newValues = this.getTreeValues(data, this.task.type.modeView)

      if (!this.allValuesAreSelected(newValues)) {
        this.addDomainValues(newValues)
      } else {
        // remove
        this.removeDomainValues(newValues)
      }
    },
    allValuesAreSelected (values) {
      var result = true
      var selectedValues = this.getSelectedKeyValues()

      for (var i = 0; i < values.length && result; i++) {
        var found = false
        for (var j = 0; j < selectedValues.length && !found; j++) {
          found = values[i] === selectedValues[j]
        }
        result = found
      }

      return result
    },
    oneValueIsSelected (values) {
      var result = false
      var selectedValues = this.getSelectedKeyValues()

      for (var i = 0; i < values.length && !result; i++) {
        for (var j = 0; j < selectedValues.length && !result; j++) {
          result = values[i] === selectedValues[j]
        }
      }

      return result
    },
    getSelectedKeyValues () {
      var result = []
      var reqObj = transport.methods.getRequestObjectById(this.definition.id, this.object)
      if (reqObj && reqObj.domainValue) {
        reqObj.domainValue.forEach((domValue) => {
          result.push(domValue.key)
        })
      }
      return result
    },
    getTreeValues (data, filter) {
      var result = []
      if (data && data.id && (!filter || filter === data.menuId)) {
        if (!result.includes(data.id)) {
          result.push(data.id)
        }
      }
      if (data.children) {
        for (var i = 0; i < data.children.length; i++) {
          result = result.concat(this.getTreeValues(data.children[i], filter))
        }
      }
      return result
    },
    addDomainValues (values) {
      var domain = this.definition.validation.domain
      var reqObj = transport.methods.getRequestObjectById(this.definition.id, this.object)
      var value, domainValue, added

      if (values.length > 0 && domain.length > 0) {
        for (var i = 0; i < values.length; i++) {
          value = values[i]

          added = false
          for (var j = 0; j < domain.length && !added; j++) {
            domainValue = domain[j]
            if (domainValue.key === value && !this.isValueSelected(reqObj, value)) {
              reqObj.domainValue.push(domainValue)
              added = true
            }
          }
        }
      }
    },
    removeDomainValues (values) {
      var reqObj = transport.methods.getRequestObjectById(this.definition.id, this.object)
      if (values && reqObj && reqObj.domainValue) {
        values.forEach((value) => {
          reqObj.domainValue = reqObj.domainValue.filter(item => {
            return item.key !== value
          })
        })
      }
    },
    isValueSelected (reqObj, value) {
      var result = false

      for (var i = 0; i < reqObj.domainValue.length && !result; i++) {
        result = reqObj.domainValue[i].key === value
      }

      return result
    }
  },
  mounted () {
    this.treeLoading = true

    api.call({domainEndpoint: this.type.domainEndpoint, url: this.task.type.endpoint, token: this.type.token, version: this.type.version, method: 'POST', lang: this.getLang(), authorization: this.authorization, data: { id: this.definitionContentId, code: this.repeatableGroupCode, requestObject: this.object }})
      .then(resp => {
        if (resp.requestResult) {
          if (resp.requestObject) {
            var reqObj = transport.methods.getRequestObjectById(this.definition.id, resp.requestObject)
            if (reqObj && reqObj.textValue) {
              this.tree = JSON.parse(reqObj.textValue)
            }
          }
        }
        this.treeLoading = false
      })
      .catch(err => {
        console.log(err)
        this.tree = null
        this.treeLoading = false
      })
  },
  watch: {
    object: {
      handler: function (value) {
        this.updateNodesStyle()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
.taskTree {
  .spinner-loading {
    position: absolute;
    top: 50%;
    left: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/task/taskTree.vue